import React from 'react';
import './gift-item.less';

/**
 * @description 礼物项的组件
 *
 * 需要支持的以下的配置
 * 1、礼物的图片
 * 2、礼物的名称
 * 3、礼物所值的钻石数量
 * 4、是否是选中的状态（可以通过外部修改）
 * 5、礼物选中的事件
 * 6、礼物是否支持选中，不支持就不显示checkbox
 */
export default class GiftItem extends React.Component {
    static defaultProps = {
        id: 0,
        name: ' ',
        image: '',
        selected: false,
        selectable: false,
        vipGrade: null,
        onSelect(id, result) {
            //  result存储的是选中和反选的情况
            console.log(id, result);
        }
    };

    constructor(props) {
        super(props);
        this.state = {
            selected: this.props.selected
        };
    }

    componentWillReceiveProps({selected}, state) {
        if (selected !== undefined) {
            this.setState({selected});
        }
    }

    itemClick = () => {
        const {selected} = this.state;
        const {id, onSelect} = this.props;
        this.setState({selected: !selected});
        onSelect(id, !selected);
    };

    render() {
        const {name, image, selectable, children, vipGrade} = this.props;
        const {selected} = this.state;
        return (
            <div className="gift-item text-center" onClick={this.itemClick}>
                <div className="gift-image">
                    <img src={image}/>
                </div>
                <div className="gift-name ellipsis">
                    {name}
                </div>
                <div className="gift-worth">
                    {children}
                </div>
                {
                    selectable ?
                        (<div className={selected ? 'gift-check' : 'gift-uncheck'}/>) :
                        null
                }
                <div className={'vipflag' + (vipGrade ? '' : ' hidden')}>
                    <span>VIP{vipGrade}</span>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./js/host/common/gift-item.js